import { IPublicClientApplication, NavigationClient, NavigationOptions } from '@azure/msal-browser'
import { Capacitor } from '@capacitor/core'
import { Browser } from '@capacitor/browser'

export class NavigationAuthenticationClient extends NavigationClient {
  constructor(private msalInstance: IPublicClientApplication) {
    super()
  }

  async navigateExternal(url: string, options: NavigationOptions): Promise<boolean> {
    if (Capacitor.isNativePlatform()) {
      // Do not launch the logout URL.
      if (url.includes('logout')) {
        return false
      } else {
        console.log('launching Browser', url)
        Browser.open({
          url: url,
          toolbarColor: '#004733',
        })

        return true
      }
    } else {
      return defaultWebHandlingLogic(url, options)
    }
  }
}

export function defaultWebHandlingLogic(url: string, options: NavigationOptions): Promise<boolean> {
  if (options.noHistory) {
    window.location.replace(url)
  } else {
    window.location.assign(url)
  }
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve(true)
    }, options.timeout)
  })
}

// A seperate function as if it is part of the constructor it will overwrite for web
export const instantiateNativeClient = (client: NavigationAuthenticationClient) => {
  NavigationClient.prototype.navigateInternal = function (url, options) {
    return defaultWebHandlingLogic(url, options)
  }

  NavigationClient.prototype.navigateExternal = client.navigateExternal
}
